<h2 mat-dialog-title>Add Name</h2>
<mat-dialog-content>
  <form [formGroup]="addNameForm">
    <mat-form-field>
      <input matInput placeholder="Name" formControlName="name" />
      <mat-error *ngIf="addNameForm.controls['name'].hasError('whitespace')"> Name cannot be blank </mat-error>
      <mat-error *ngIf="addNameForm.controls['name'].hasError('minlength')"> Name must be at least 3 characters long </mat-error>
      <mat-error *ngIf="addNameForm.controls['name'].hasError('specialCharacters')"> Name can only contain letters and spaces </mat-error>
    </mat-form-field>
    <mat-radio-group formControlName="gender">
      <mat-radio-button class="mr-2" value="Male">Male</mat-radio-button>
      <mat-radio-button value="Female">Female</mat-radio-button>
    </mat-radio-group>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="warn" (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="addNameForm.value" [disabled]="!addNameForm.valid" cdkFocusInitial>Confirm</button>
</mat-dialog-actions>
